import { createAction, props } from "@ngrx/store";
import { ApplicationState } from "./application.state";
import { RecursivePartial } from "../recursive-partial";
import { Toast } from "../../app/shared/components/toast/toast";

export const InitializeAction = createAction(
    "[Application] Initialize",
);

export const ExtendStateAction = createAction(
    "[Application] Extend State",
    props<{ newState: Partial<ApplicationState> }>(),
);

export const MergeStateAction = createAction(
    "[Application] Merge State",
    props<{ newState: RecursivePartial<ApplicationState> }>(),
);

export const SearchAction = createAction(
    "[Application] Search",
    props<{ searchTerm: string }>(),
);

export const ShowToastAction = createAction(
    "[Application] Show Toast",
    props<{ toast: Toast }>()
);

export const HideToastAction = createAction(
    "[Application] Hide Toast",
    props<{ toast: Toast }>()
);
